import { useCallback } from 'react';
import { searchEntries } from '../data/searchEntries';
//import { useNotify } from '../context/NotificationContext';

/**
 * React hook – returns a memoised `doSearch` function.
 */
export function useSearchEntries() {
  //const notify = useNotify();

  return useCallback(async (params) => {
    try {
      return await searchEntries(params);
    } catch (err) {
      //notify.show('Search failed');
      console.log('SEARCH FAILED');
      throw err;
    }
  }, []);
}
